<div class="transfers-selector">
  <div
    class="transfers-selector__description"
    data-qa="transfersSelector_description"
    i18n
    *ngIf="(activeFlow$ | async) === Flows.Adult; else juniorDisclaimer"
  >
    Our transfer services can take you directly to or from your school or accommodation.
  </div>

  <div class="transfers-selector__same-arrival-departure">
    <p-inputSwitch
      [(ngModel)]="roundTrip"
      (onChange)="preselectTransferRows()"
      data-qa="transfersSelector_sameArrivalDeparture_switch"
      [lxGAClickEvent]="sameArrivalDepartureEventName"
    />
    <div
      class="transfers-selector__same-arrival-departure__label"
      [ngClass]="{ 'transfers-selector__same-arrival-departure__label--off': !roundTrip }"
      data-qa="transfersSelector_sameArrivalDeparture_label"
      i18n
    >
      Same arrival and departure location for transfers
    </div>
  </div>

  <div *ngIf="roundTrip" class="transfers-selector__selectable-transfers">
    <lx-transfer-selector-options
      [transfers]="roundTripTransfers"
      [(selectedTransferRow)]="selectedTransferRows[transferTypes.ARRIVAL]"
      (selectedTransferRowChange)="setSelectedTransferRow($event)"
      (cleanSelectedTransferRow)="removeSelectedTransferRow($event)"
    ></lx-transfer-selector-options>
  </div>

  <div *ngIf="!roundTrip" class="transfers-selector__selectable-transfers">
    <div class="transfers-selector__selectable-transfers__title" i18n>Arrival (Pick-up)</div>
    <lx-transfer-selector-options
      [transfers]="groupedTransfers[transferTypes.ARRIVAL]"
      [(selectedTransferRow)]="selectedTransferRows[transferTypes.ARRIVAL]"
      (selectedTransferRowChange)="setSelectedTransferRow($event)"
      (cleanSelectedTransferRow)="removeSelectedTransferRow($event)"
    ></lx-transfer-selector-options>
  </div>

  <div *ngIf="!roundTrip" class="transfers-selector__selectable-transfers">
    <div class="transfers-selector__selectable-transfers__title" i18n>Departure (Drop-off)</div>
    <lx-transfer-selector-options
      [transfers]="groupedTransfers[transferTypes.DEPARTURE]"
      [(selectedTransferRow)]="selectedTransferRows[transferTypes.DEPARTURE]"
      (selectedTransferRowChange)="setSelectedTransferRow($event)"
      (cleanSelectedTransferRow)="removeSelectedTransferRow($event)"
    ></lx-transfer-selector-options>
  </div>

  <div class="transfers-selector__disclaimer" data-qa="transfersSelector_disclaimer" *ngIf="(activeFlow$ | async) === Flows.Adult">
    <div class="transfers-selector__disclaimer__title" data-qa="transfersSelector_disclaimer_title" i18n>Please note</div>

    <div class="transfers-selector__disclaimer__body" data-qa="transfersSelector_disclaimer_body" i18n>
      The prices displayed are for private taxi transfers, but other transfer options are available. You'll select your pickup times later, once your booking is
      confirmed with your Advisor.
    </div>
  </div>
</div>

<ng-template #juniorDisclaimer>
  <div i18n class="transfers-selector__description" data-qa="transfersSelector_description">Our transfers take you to and from any camp.</div>
  <div i18n class="transfers-selector__description" data-qa="transfersSelector_description">
    Prices below are for <strong>Collective transfers</strong> (Sunday arrival & Saturday departure, 8:00–19:00).
  </div>
  <div i18n class="transfers-selector__description" data-qa="transfersSelector_description">
    Private transfers are required outside these times—contact our advisors for details.
  </div>
</ng-template>
